import { MenuItem, Select } from "@material-ui/core";
import React, { Component } from "react";
import styled from "styled-components";

import { LibraryView } from "common/constants";
import { ActionPermissionsObject, PermissionActionType, WorkspacePlanTier } from "common/interfaces";
import WorkspaceController from "js/controllers/WorkspaceController";
import { getStaticUrl } from "js/config";
import { app } from "js/namespaces";
import UpgradeIcon from "js/Components/UpgradeIcon";
import { FlexBox } from "js/react/components/LayoutGrid";
import { Divider } from "js/react/components/UiComponents";

const MyPresentationsTitle = styled.div`
    padding: 10px;
    font-size: 16px;
    color: #000;
    border: none;
    cursor: pointer;
    background: transparent;
    font-weight: 600;
    font-family: "Source Sans Pro";
    text-transform: uppercase;
`;

const StyledMenuItem = styled(MenuItem)`
    &&& {
        justify-content: space-between;
    }
`;

export class PresentationLibraryViewSelect extends Component {
    render() {
        const { libraryView, onSwitchType, isMyPresentationsOnly } = this.props;

        const isBasic = WorkspaceController.plan.tier === WorkspacePlanTier.BASIC;
        const canCreateResources = !app.integrator && WorkspaceController.actionPermissions[ActionPermissionsObject.RESOURCES].create;
        const canUpgradeToCreateResources = !app.integrator && WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.RESOURCES, PermissionActionType.CREATE);
        const canManageSharedSlides = !app.integrator && WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage;
        const canUpgradeToManageSharedSlides = !isBasic && !app.integrator && WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.SHARED_RESOURCES, PermissionActionType.MANAGE);

        return (
            <>
                {isMyPresentationsOnly ? (
                    <MyPresentationsTitle>My Presentations</MyPresentationsTitle>
                ) : (
                    <Select
                        id="libraryType"
                        value={libraryView}
                        onChange={event => onSwitchType(event.target.value)}
                        disableUnderline
                        renderValue={value => {
                            if (value === LibraryView.TEAM_RESOURCES) {
                                return (
                                    <FlexBox left>
                                        {canUpgradeToManageSharedSlides && (
                                            <UpgradeIcon style={{ marginRight: 8 }} />
                                        )}
                                        Team Resources
                                    </FlexBox>
                                );
                            } else if (value === LibraryView.MY_RESOURCES) {
                                return (
                                    <FlexBox left>
                                        {canUpgradeToCreateResources && (
                                            <UpgradeIcon style={{ marginRight: 8 }} />
                                        )}
                                        My Resources
                                    </FlexBox>
                                );
                            }

                            return "My Presentations";
                        }}
                    >
                        <MenuItem value={LibraryView.LIBRARY}>My Presentations</MenuItem>
                        {(canCreateResources || canUpgradeToCreateResources) && (
                            <MenuItem value={LibraryView.MY_RESOURCES}>
                                My Resources
                                {canUpgradeToCreateResources && (
                                    <UpgradeIcon style={{ marginLeft: "auto" }} />
                                )}
                            </MenuItem>
                        )}
                        {(canManageSharedSlides || canUpgradeToManageSharedSlides) && (
                            <MenuItem value={LibraryView.TEAM_RESOURCES}>
                                Team Resources
                                {canUpgradeToManageSharedSlides && (
                                    <UpgradeIcon style={{ marginLeft: "auto" }} />
                                )}
                            </MenuItem>
                        )}
                    </Select>
                )}
                <Divider margin={10} />
            </>
        );
    }
}
